import { apiClient } from '../../axios';
import {
  GetMfaStatusParams,
  GetMfaStatusResponse,
  PostMfaInitiateParams,
  PostMfaInitiateResponse,
  PostMfaPasskeyAuthParams,
  PostMfaPasskeyAuthResponse,
  PostMfaRequestParams,
  PostMfaRequestResponse,
  PostMfaVerifyParams,
  PostMfaVerifyResponse,
} from './types';

export const postMfaInitiateApi = (params: PostMfaInitiateParams) =>
  apiClient.post<PostMfaInitiateResponse>('/v1/mfa/initiate', params);

export const postMfaRequestApi = (params: PostMfaRequestParams) =>
  apiClient.post<PostMfaRequestResponse>('/v1/mfa/request', params);

export const postMfaVerifyApi = (params: PostMfaVerifyParams) =>
  apiClient.post<PostMfaVerifyResponse>('/v1/mfa/verify', params);

export const getMfaStatusApi = (params?: GetMfaStatusParams) =>
  apiClient.get<GetMfaStatusResponse>('/v1/mfa/status', { params });

export const postMfaPasskeyAuthApi = (params: PostMfaPasskeyAuthParams) =>
  apiClient.post<PostMfaPasskeyAuthResponse>('/v1/user/passkey/mfa', params);
